import React, { useState, useEffect } from 'react';
import Footer from '../layout/Footer';
import { Container, Row, Col, Card, Form, Button, Table } from 'react-bootstrap';
import SendSms from './SendSms';
// Datatable
import JSZip from 'jszip';
import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import $ from "jquery";
import DataTable from 'datatables.net-dt';

// icon
import Icon from '@mdi/react';
import { mdiTrashCanOutline, mdiMagnify, mdiPlus } from '@mdi/js';
import FormInputs from '../../Utils/FormInputs';

export default function Marketing() {
    // datatable
    DataTable.Buttons.jszip(JSZip);
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    useEffect(() => {
        if (!$.fn.dataTable.isDataTable('#mainDatatableSMSHistory')) {
            $('#mainDatatableSMSHistory').DataTable({
                dom: "flrtip",
                language: {
                    search: '',
                    searchPlaceholder: "Search...",
                    paginate: {
                        previous: '«',
                        next: '»'
                    },
                }
            });
        }
    }, []);

    const initialInputData = {
        name: '',
        automated_date: '',
        target_segments: '',
        sms_templates: '',
        description: '',
        custom_sms_name: '',
        sms_text_content: '',
        custom_sms_description: '',
        select_one: '',
        select_two: '',
        select_time: '',
    }

    const [inputData, setInputData] = useState(initialInputData);

    // Automated SMS
    const handleMrkAutoSmsChange = (index, field, value) => {
        setInputData({ ...inputData, [field]: value });
    };
    const handleMrkAutoSmsSubmit = (e) => {
        e.preventDefault();
    };
    const mrkAutoSmsRows = [
        {
            columns: [
                { size: { sm: 12 }, tag: 'h5', type: 'normaltext', class: 'mb-3', text: 'Automated SMS', },
                { size: { md: 6, xxl: 3 }, label: 'Name', type: 'text', placeholder: 'Enter name...', name: 'name', id: 'name', value: inputData.name, errormsg: '', },
                {
                    size: { md: 6, xxl: 3 }, label: 'Automated Date', type: 'select', name: 'automated_date', id: 'automatedDate', value: inputData.automated_date, errormsg: '',
                    options: [
                        { value: '', label: 'No' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                {
                    size: { md: 6, xxl: 3 }, label: 'Target Segments', type: 'select', name: 'target_segments', id: 'targetSegments', value: inputData.target_segments, errormsg: '',
                    options: [
                        { value: '', label: 'Select Target Segment' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                {
                    size: { md: 6, xxl: 3 }, label: 'SMS Templates', type: 'select', name: 'sms_templates', id: 'targetSegments', value: inputData.sms_templates, errormsg: '',
                    options: [
                        { value: '', label: 'Compose SMS Template' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                { size: { sm: 12 }, label: 'Description', type: 'textarea', placeholder: 'Type description...', formrow: '3', name: 'description', id: 'description', value: inputData.description, errormsg: '', },
            ]
        }
    ];
    const mrkAutoSmsButtons = [
        { variant: "primary", text: "Save", },
        { variant: "secondary", text: "Cancel", },
    ];

    // Custom Sms Form
    const handleMrkCustomSmsInputChange = (index, field, value) => {
        setInputData({ ...inputData, [field]: value });
    };
    const handleMrkCustomSmsSubmit = (e) => {
        e.preventDefault();
    };
    const mrkCustomSmsRows = [
        {
            columns: [
                { size: { sm: 12 }, tag: 'h5', type: 'normaltext', class: 'mb-3', text: 'Custom SMS', },
                { size: { sm: 12 }, label: 'Name', type: 'text', placeholder: 'Enter name...', name: 'custom_sms_name', id: 'custom_sms_name', value: inputData.custom_sms_name, errormsg: '', },
                { size: { lg: 6 }, label: 'Sms Text Content', type: 'textarea', placeholder: 'Type sms...', formrow: '3', name: 'sms_text_content', id: 'smsTextContent', value: inputData.sms_text_content, errormsg: '', },
                { size: { lg: 6 }, label: 'Description', type: 'textarea', placeholder: 'Type description...', formrow: '3', name: 'custom_sms_description', id: 'customSmsDescription', value: inputData.custom_sms_description, errormsg: '', },
                {
                    size: { lg: 12 }, type: 'button', additionalClass: 'justify-content-end mb-3',
                    buttons: [
                        { color: 'primary', icon: mdiPlus, id: 'addProduct', text: 'Add Template' }
                    ]
                },
            ]
        }
    ];
    const mrkCustomSmsButtons = [];

    // SMS History Form
    const handleMrkSmsHistoryInputChange = (index, field, value) => {
        setInputData({ ...inputData, [field]: value });
    };
    const handleMrkSmsHistorySubmit = (e) => {
        e.preventDefault();
    };
    const mrkSmsHistoryRows = [
        {
            columns: [
                { size: { sm: 12 }, tag: 'h5', type: 'normaltext', class: 'mb-3', text: 'SMS History', },
                {
                    size: { md: 6, lg: 4 }, label: 'Select', type: 'select', name: 'select_one', id: 'selectOne', value: inputData.select_one, errormsg: '',
                    options: [
                        { value: '', label: 'Select' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                {
                    size: { md: 6, lg: 4 }, label: 'Select', type: 'select', name: 'select_two', id: 'selectTwo', value: inputData.select_two, errormsg: '',
                    options: [
                        { value: '', label: 'Select' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                {
                    size: { lg: 4 }, label: 'Select Time', type: 'select', name: 'select_time', id: 'selectTime', value: inputData.select_time, errormsg: '',
                    options: [
                        { value: '', label: 'Select' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
            ]
        },
        {
            columns: [
                {
                    size: { md: 12 }, type: 'normaltextlist', ulclass: 'list-inline text-dark mb-1 fs-16 mb-2', liclass: 'list-inline-item me-5 mb-2 pe-5 mb-2',
                    listItems: [
                        { listtext: '0 Sucessful' },
                        { listtext: '0 Failed' },
                        { listtext: '0 Total' },
                        { listtext: '0 DND' },
                        { listtext: '0 Unknown' },
                    ],
                },
            ]
        },
    ];
    const mrkSmsHistoryButtons = [];

    return (
        <>
            <div className="page-wrapper">
                <div className='page-content'>
                    <Container>
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className='custom-top-nav-tab'>
                                            <ul className="nav nav-pills nav-fill btn-list mb-3" id="pills-tab" role="tablist">
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link active" id="pills-send-sms-tab" data-bs-toggle="pill" data-bs-target="#pills-send-sms" type="button" role="tab" aria-controls="pills-send-sms" aria-selected="true">Send SMS</button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link" id="pills-automated-sms-tab" data-bs-toggle="pill" data-bs-target="#pills-automated-sms" type="button" role="tab" aria-controls="pills-automated-sms" aria-selected="false">Automated SMS</button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link" id="pills-schedule-sms-tab" data-bs-toggle="pill" data-bs-target="#pills-schedule-sms" type="button" role="tab" aria-controls="pills-schedule-sms" aria-selected="false">Schedule SMS</button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link" id="pills-custom-sms-tab" data-bs-toggle="pill" data-bs-target="#pills-custom-sms" type="button" role="tab" aria-controls="pills-custom-sms" aria-selected="false">Custom SMS</button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link" id="pills-custom-target-segment-tab" data-bs-toggle="pill" data-bs-target="#pills-custom-target-segment" type="button" role="tab" aria-controls="pills-custom-target-segment" aria-selected="false">Custom Target Segment</button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link" id="pills-manage-groups-tab" data-bs-toggle="pill" data-bs-target="#pills-manage-groups" type="button" role="tab" aria-controls="pills-manage-groups" aria-selected="false">Manage Groups</button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link" id="pills-sms-history-tab" data-bs-toggle="pill" data-bs-target="#pills-sms-history" type="button" role="tab" aria-controls="pills-sms-history" aria-selected="false">SMS History</button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link" id="pills-sms-conversion-tab" data-bs-toggle="pill" data-bs-target="#pills-sms-conversion" type="button" role="tab" aria-controls="pills-sms-conversion" aria-selected="false">SMS Conversion</button>
                                                </li>
                                            </ul>

                                            <div className="tab-content" id="pills-tabContent">
                                                <div className="tab-pane fade show active" id="pills-send-sms" role="tabpanel" aria-labelledby="pills-send-sms-tab" tabIndex="0">
                                                    <SendSms />
                                                </div>
                                                <div className="tab-pane fade" id="pills-automated-sms" role="tabpanel" aria-labelledby="pills-automated-sms-tab" tabIndex="0">
                                                    <FormInputs Buttons={mrkAutoSmsButtons} rows={mrkAutoSmsRows} handleInputChange={handleMrkAutoSmsChange} handleSubmit={handleMrkAutoSmsSubmit} />
                                                </div>
                                                <div className="tab-pane fade" id="pills-schedule-sms" role="tabpanel" aria-labelledby="pills-schedule-sms-tab" tabIndex="0">
                                                    <Card.Title>Schedule SMS</Card.Title>
                                                    <Card className='border shadow-none'>
                                                        <Card.Body>
                                                            <div className="d-flex justify-content-between">
                                                                <div>
                                                                    <h5 className='fs-16 mb-3'>Add Schedule SMS</h5>
                                                                    <h5 className='fs-16 mb-3'>Add Customers - Welcome</h5>
                                                                    <h5 className='fs-16 mb-3'>Hi, Welcome to F spa and salon, Thank you for making us your choice.</h5>
                                                                    <h5 className='fs-16 mb-3'>Selected Customers</h5>
                                                                    <h5 className='fs-16 mb-0'>JK Patel (9687623125)</h5>
                                                                </div>
                                                                <a href="/">
                                                                    <div className='avatar avatar-sm bg-soft-danger text-danger'>
                                                                        <Icon path={mdiTrashCanOutline} className='avatar-icon' />
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                    <Card className='border shadow-none mb-0'>
                                                        <Card.Body className='pb-0'>
                                                            <Card.Title>Selected Customers</Card.Title>
                                                            <Row className='justify-content-between align-items-end'>
                                                                <Col lg={9} xl={8} xxl={6}>
                                                                    <Row>
                                                                        <Col md={6}>
                                                                            <div className="mb-3 custom-form-input">
                                                                                <Form.Label>Selected Customers</Form.Label>
                                                                                <Form.Select >
                                                                                    <option>All</option>
                                                                                    <option value="1">One</option>
                                                                                    <option value="2">Two</option>
                                                                                </Form.Select>
                                                                            </div>
                                                                        </Col>
                                                                        <Col md={6}>
                                                                            <div className="mb-3 custom-form-input">
                                                                                <Form.Label>Customer Name</Form.Label>
                                                                                <Form.Select >
                                                                                    <option>Select Customer Name</option>
                                                                                    <option value="1">One</option>
                                                                                    <option value="2">Two</option>
                                                                                </Form.Select>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col lg={3} xl={4} xxl={3}>
                                                                    <Form className='custom-form-width mw-100 mb-3'>
                                                                        <div className='custom-search-bar'>
                                                                            <Icon path={mdiMagnify} size={1} className="custom-search-input-icon" />
                                                                            <Form.Control className='' type="text" placeholder="Search customers..." name='customersSearch' id='customersSearch' />
                                                                        </div>
                                                                    </Form>
                                                                </Col>
                                                            </Row>
                                                        </Card.Body>
                                                    </Card>
                                                </div>
                                                <div className="tab-pane fade" id="pills-custom-sms" role="tabpanel" aria-labelledby="pills-custom-sms-tab" tabIndex="0">
                                                    <FormInputs Buttons={mrkCustomSmsButtons} rows={mrkCustomSmsRows} handleInputChange={handleMrkCustomSmsInputChange} handleSubmit={handleMrkCustomSmsSubmit} />
                                                </div>
                                                <div className="tab-pane fade" id="pills-custom-target-segment" role="tabpanel" aria-labelledby="pills-custom-target-segment-tab" tabIndex="0">
                                                    <Card.Title>Custom Target Segment</Card.Title>
                                                    <Card className='border shadow-none mb-0'>
                                                        <Card.Body>
                                                            <h5 className='fs-16 fw-normal mb-3'>SMS Marketing [Custom SMS Templates]</h5>
                                                            <h5 className='fs-16 fw-normal mb-3'>Custom SMS Templates</h5>
                                                            <div className="text-end">
                                                                <Button variant="primary"><Icon path={mdiPlus} className="btn-icon me-1" /> Add Template</Button>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                </div>
                                                <div className="tab-pane fade" id="pills-manage-groups" role="tabpanel" aria-labelledby="pills-manage-groups-tab" tabIndex="0">
                                                    <Card.Title>Manage Groups</Card.Title>
                                                    <Card className='border shadow-none mb-0'>
                                                        <Card.Body>
                                                            <h5 className='fs-16 fw-normal mb-3'>SMS Marketing [Manage Groups]</h5>
                                                            <h5 className='fs-16 fw-normal mb-3'>Groups</h5>
                                                            <div className="text-end">
                                                                <Button variant="primary">View Invoice</Button>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                </div>
                                                <div className="tab-pane fade" id="pills-sms-history" role="tabpanel" aria-labelledby="pills-sms-history-tab" tabIndex="0">
                                                    <FormInputs Buttons={mrkSmsHistoryButtons} rows={mrkSmsHistoryRows} handleInputChange={handleMrkSmsHistoryInputChange} handleSubmit={handleMrkSmsHistorySubmit} />
                                                    <Table responsive bordered className='table-nowrap' id='mainDatatableSMSHistory'>
                                                        <thead className='table-light'>
                                                            <tr>
                                                                <th>Sms Content</th>
                                                                <th>Created Date and Time</th>
                                                                <th>Customer Name</th>
                                                                <th>Customer Mobile No</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>500</td>
                                                                <td>28/12/2022 <span className='ms-3'>09:15 AM</span></td>
                                                                <td>Sarah C. Jolley</td>
                                                                <td>(+91) 1234 5678 90</td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </div>
                                                <div className="tab-pane fade" id="pills-sms-conversion" role="tabpanel" aria-labelledby="pills-sms-conversion-tab" tabIndex="0">
                                                    <Card.Title>SMS Conversion</Card.Title>
                                                    <h5 className='fs-16 fw-normal mb-3'>SMS Marketing [SMS Conversion]</h5>
                                                    <Card className='border shadow-none mb-0'>
                                                        <Card.Body className='pb-0'>
                                                            <Card.Title>Selected Customers</Card.Title>
                                                            <Row className='justify-content-between align-items-end'>
                                                                <Col lg={9} xl={8} xxl={6}>
                                                                    <Row>
                                                                        <Col md={6}>
                                                                            <div className="mb-3">
                                                                                <Form.Select >
                                                                                    <option>All Time</option>
                                                                                    <option value="1">One</option>
                                                                                    <option value="2">Two</option>
                                                                                </Form.Select>
                                                                            </div>
                                                                        </Col>
                                                                        <Col md={6}>
                                                                            <div className="mb-3">
                                                                                <Form.Select >
                                                                                    <option>All</option>
                                                                                    <option value="1">One</option>
                                                                                    <option value="2">Two</option>
                                                                                </Form.Select>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col lg={3} xl={4} xxl={3}>
                                                                    <Form className='custom-form-width mw-100 mb-3'>
                                                                        <div className='custom-search-bar'>
                                                                            <Icon path={mdiMagnify} size={1} className="custom-search-input-icon" />
                                                                            <Form.Control className='' type="text" placeholder="Search..." name='customersSearch' id='customersSearch' />
                                                                        </div>
                                                                    </Form>
                                                                </Col>
                                                            </Row>
                                                        </Card.Body>
                                                    </Card>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
        </>
    )
}
